import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  key: 1,
  class: "guest-content"
}

import { ref, onMounted, onUnmounted, computed } from 'vue'
import DesktopNavigation from '@/components/base/DesktopNavigation.vue'
import MobileNavigation from '@/components/base/MobileNavigation.vue'
import { useRoute } from 'vue-router'
import { authStore } from '@/stores/auth'
import DesktopFooter from '@/components/base/DesktopFooter.vue'
import MobileFooter from '@/components/base/MobileFooter.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()

const isMobile = ref(false)

const showMainTemplate = computed(() => {
  return authStore().loggedIn && typeof route.name === 'string' && !['Login'].includes(route.name)
})

onMounted(() => {
  checkIfMobile()
  window.addEventListener('resize', checkIfMobile)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkIfMobile)
})

function checkIfMobile () : void {
  isMobile.value = window.innerWidth <= 768
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (showMainTemplate.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (isMobile.value)
          ? (_openBlock(), _createBlock(MobileNavigation, { key: 0 }))
          : _createCommentVNode("", true),
        (!isMobile.value)
          ? (_openBlock(), _createBlock(DesktopNavigation, { key: 1 }))
          : _createCommentVNode("", true),
        _createElementVNode("main", _hoisted_2, [
          _createVNode(_component_router_view),
          (!isMobile.value)
            ? (_openBlock(), _createBlock(DesktopFooter, { key: 0 }))
            : _createCommentVNode("", true),
          (isMobile.value)
            ? (_openBlock(), _createBlock(MobileFooter, { key: 1 }))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createElementBlock("main", _hoisted_3, [
        _createVNode(_component_router_view)
      ]))
}
}

})